import { getExactKeyPath, setKeyPath } from 'customer-data-filters-ui/filterQueryFormat/logic/LogicGroup';
import { isValidCondition } from '../filterQueryFormat/logic/LogicGroup';
import { useCallback, useContext } from 'react';
import { useEditorActions } from './useEditorActions';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
import { useValidateCondition } from './useValidateCondition';
import { isOperator } from 'customer-data-filters-ui/filterQueryFormat/operator/Operator';
export const useValidateDraftCondition = () => {
  const {
    draftCondition,
    internalDraftValue
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    validateCondition
  } = useValidateCondition();
  const {
    onChangeInternal
  } = useEditorActions();
  const validateDraftCondition = useCallback(() => {
    if (!draftCondition || !draftCondition.conditionPath) {
      return;
    }
    const condition = getExactKeyPath(draftCondition.conditionPath, internalDraftValue);
    if (!condition || !isOperator(condition)) {
      return;
    }
    const validatedCondition = validateCondition(draftCondition.filterFamily, condition);
    if (!isValidCondition(validatedCondition)) {
      const newInternalDraftValue = setKeyPath(draftCondition.conditionPath, validatedCondition, internalDraftValue);
      onChangeInternal(newInternalDraftValue);
    }
  }, [draftCondition, internalDraftValue, onChangeInternal, validateCondition]);
  return {
    validateDraftCondition
  };
};